/* StalkMaster quick add for collection cards.
   Sugar 2.1.1 renders <quick-add-modal> and single-variant product forms on collection cards,
   but on collection pages neither the modal element nor product-form.js is loaded, so
   "Choose options" does nothing and "Add to cart" submits the form and leaves the page.
   This file adds both behaviours: add to cart without leaving the collection, then open the cart drawer. */
(function () {
  if (window.__smQuickAdd) return;
  window.__smQuickAdd = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var css = '' +
    'quick-add-modal{position:fixed;inset:0;z-index:1000;display:none;align-items:center;justify-content:center;background:rgba(0,0,0,.5);padding:16px}' +
    'quick-add-modal[open]{display:flex}' +
    'quick-add-modal .quick-add-modal__content{position:relative;background:rgb(var(--color-background,244,243,239));color:rgb(var(--color-foreground,28,30,27));width:min(520px,100%);max-height:90vh;overflow:auto;border-radius:8px;padding:22px;box-shadow:0 12px 40px rgba(0,0,0,.25)}' +
    'quick-add-modal .quick-add-modal__toggle{position:absolute;top:10px;right:10px;width:36px;height:36px;border:0;background:transparent;color:inherit;cursor:pointer;display:flex;align-items:center;justify-content:center}' +
    'quick-add-modal .quick-add-modal__toggle svg{width:18px;height:18px}' +
    '.smqa__top{display:grid;grid-template-columns:96px 1fr;gap:14px;align-items:center;margin:0 36px 16px 0}' +
    '.smqa__img{width:96px;height:96px;object-fit:cover;border-radius:6px;background:rgba(var(--color-foreground),.06)}' +
    '.smqa__title{font-weight:700;font-size:16px;line-height:1.25;margin:0 0 6px}' +
    '.smqa__price{font-size:15px;font-weight:700}.smqa__price s{font-weight:400;opacity:.6;margin-left:8px}' +
    '.smqa__opt{border:0;margin:0 0 14px;padding:0}' +
    '.smqa__opt legend{font-size:12px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;margin-bottom:8px;padding:0}' +
    '.smqa__vals{display:flex;flex-wrap:wrap;gap:8px}' +
    '.smqa__val{border:1px solid rgba(var(--color-foreground),.3);background:transparent;color:inherit;border-radius:4px;padding:9px 13px;font:inherit;font-size:14px;cursor:pointer;min-width:44px}' +
    '.smqa__val[aria-pressed="true"]{background:rgb(var(--color-foreground));color:rgb(var(--color-background));border-color:rgb(var(--color-foreground))}' +
    '.smqa__val.is-unavailable{text-decoration:line-through;opacity:.45}' +
    '.smqa__add{display:block;width:100%;min-height:48px;border:0;border-radius:4px;margin-top:6px;font:inherit;font-weight:700;font-size:15px;cursor:pointer;background:rgb(var(--color-button,var(--color-foreground)));color:rgb(var(--color-button-text,var(--color-background)))}' +
    '.smqa__add[disabled]{opacity:.5;cursor:not-allowed}' +
    '.smqa__msg{font-size:13px;margin-top:8px;min-height:1em}' +
    '.smqa__link{display:inline-block;margin-top:10px;font-size:13px;text-decoration:underline}' +
    '.smqa__loading{padding:30px 0;text-align:center;opacity:.7}' +
    'body.sm-qa-lock{overflow:hidden}' +
    '@media (max-width:749px){quick-add-modal{align-items:flex-end;padding:0}quick-add-modal .quick-add-modal__content{width:100%;border-radius:12px 12px 0 0;max-height:85vh;padding:20px 16px calc(20px + env(safe-area-inset-bottom,0px))}}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function addToCart(variantId) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'This item could not be added.');
          return data;
        });
      })
      .then(function () {
        return fetch(root + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        try {
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'sm-quick-add', productVariantId: Number(variantId), cartData: cart });
          }
        } catch (e) {}
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { cart: cart } }));
        var drawer = document.querySelector('sugar-cart-drawer');
        if (!drawer) {
          window.location.href = root + 'cart';
          return cart;
        }
        var refreshed;
        try { refreshed = drawer.refresh && drawer.refresh(); } catch (e) {}
        return Promise.resolve(refreshed).catch(function () {}).then(function () {
          try { drawer.open && drawer.open(); } catch (e) {}
          return cart;
        });
      });
  }

  function optionNames(p) {
    return (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
  }

  function optionValues(p, i) {
    var o = (p.options || [])[i];
    if (o && typeof o === 'object' && o.values) return o.values;
    var seen = [];
    p.variants.forEach(function (v) { var x = v.options[i]; if (seen.indexOf(x) === -1) seen.push(x); });
    return seen;
  }

  class SmQuickAddModal extends HTMLElement {}

  SmQuickAddModal.prototype.connectedCallback = function () {
    if (this._ready) return;
    this._ready = true;
    var self = this;
    this.info = this.querySelector('.quick-add-modal__content-info');
    var toggle = this.querySelector('.quick-add-modal__toggle');
    if (toggle) toggle.addEventListener('click', function () { self.hide(); });
    this.addEventListener('click', function (e) { if (e.target === self) self.hide(); });
    this.addEventListener('keyup', function (e) { if (e.key === 'Escape') self.hide(); });
  };

  SmQuickAddModal.prototype.show = function (opener) {
    var self = this;
    this.opener = opener || null;
    var url = (opener && opener.getAttribute('data-product-url')) || '';
    if (!url || !this.info) return;
    if (this.parentElement !== document.body) document.body.appendChild(this);
    this.info.innerHTML = '<div class="smqa__loading">Loading…</div>';
    this.setAttribute('open', '');
    document.body.classList.add('sm-qa-lock');
    fetch(url.split('?')[0] + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) { self.product = p; self.render(); })
      .catch(function () {
        self.info.innerHTML = '<p class="smqa__msg">This product could not be loaded. <a class="smqa__link" href="' + esc(url) + '">Open the product page</a></p>';
      });
  };

  SmQuickAddModal.prototype.hide = function () {
    this.removeAttribute('open');
    document.body.classList.remove('sm-qa-lock');
    if (this.opener && this.opener.focus) this.opener.focus();
  };

  SmQuickAddModal.prototype.render = function () {
    var self = this;
    var p = this.product;
    var names = optionNames(p);
    var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    this.sel = first.options.slice();
    var html = '<div class="smqa__top"><img class="smqa__img" alt=""><div><p class="smqa__title">' + esc(p.title) + '</p><div class="smqa__price"></div></div></div>';
    names.forEach(function (n, i) {
      html += '<fieldset class="smqa__opt"><legend>' + esc(n) + '</legend><div class="smqa__vals">';
      optionValues(p, i).forEach(function (val) {
        html += '<button type="button" class="smqa__val" data-i="' + i + '" data-v="' + esc(val) + '">' + esc(val) + '</button>';
      });
      html += '</div></fieldset>';
    });
    html += '<button type="button" class="smqa__add">Add to cart</button><div class="smqa__msg" role="status"></div>' +
      '<a class="smqa__link" href="' + esc(p.url) + '">View full product details</a>';
    this.info.innerHTML = html;
    this.info.querySelectorAll('.smqa__val').forEach(function (b) {
      b.addEventListener('click', function () {
        self.sel[Number(b.getAttribute('data-i'))] = b.getAttribute('data-v');
        self.update();
      });
    });
    this.info.querySelector('.smqa__add').addEventListener('click', function () { self.submit(); });
    this.update();
    var focusTarget = this.info.querySelector('.smqa__val') || this.info.querySelector('.smqa__add');
    if (focusTarget) focusTarget.focus();
  };

  SmQuickAddModal.prototype.current = function () {
    var sel = this.sel;
    return this.product.variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === sel[i]; });
    })[0] || null;
  };

  SmQuickAddModal.prototype.update = function () {
    var self = this;
    var p = this.product;
    var v = this.current();
    this.info.querySelectorAll('.smqa__val').forEach(function (b) {
      var i = Number(b.getAttribute('data-i'));
      var val = b.getAttribute('data-v');
      b.setAttribute('aria-pressed', self.sel[i] === val ? 'true' : 'false');
      var possible = p.variants.some(function (x) {
        return x.available && x.options.every(function (o, k) { return k === i ? o === val : o === self.sel[k]; });
      });
      b.classList.toggle('is-unavailable', !possible);
    });
    var priceEl = this.info.querySelector('.smqa__price');
    var shown = v || p.variants[0];
    priceEl.innerHTML = money(shown.price) + (shown.compare_at_price > shown.price ? '<s>' + money(shown.compare_at_price) + '</s>' : '');
    var img = this.info.querySelector('.smqa__img');
    var src = (v && v.featured_image && v.featured_image.src) || p.featured_image;
    if (src) img.src = (src.indexOf('//') === 0 ? 'https:' + src : src) + (src.indexOf('?') === -1 ? '?' : '&') + 'width=240';
    img.alt = p.title;
    var add = this.info.querySelector('.smqa__add');
    var ok = !!(v && v.available);
    add.disabled = !ok;
    add.textContent = !v ? 'Unavailable' : (v.available ? 'Add to cart' : 'Sold out');
    this.info.querySelector('.smqa__msg').textContent = '';
  };

  SmQuickAddModal.prototype.submit = function () {
    var self = this;
    var v = this.current();
    if (!v || !v.available) return;
    var add = this.info.querySelector('.smqa__add');
    var msg = this.info.querySelector('.smqa__msg');
    add.disabled = true;
    add.textContent = 'Adding…';
    addToCart(v.id)
      .then(function () { self.hide(); })
      .catch(function (err) {
        msg.textContent = err.message;
        add.disabled = false;
        add.textContent = 'Add to cart';
      });
  };

  if (!customElements.get('quick-add-modal')) customElements.define('quick-add-modal', SmQuickAddModal);

  /* Single-variant cards: the theme renders a plain product form. Without product-form.js it submits and leaves the page. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
    if (customElements.get('product-form')) return;
    if (!form.closest('.sugar-card, [class*="sugar-card"], [class*="featured-collection"]')) return;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    addToCart(idInput.value)
      .catch(function (err) { console.warn('Quick add failed:', err); })
      .then(function () {
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = label; }
      });
  }, true);
})();
